import { render, staticRenderFns } from "./ChoiceCard.vue?vue&type=template&id=7be9aa67&"
import script from "./ChoiceCard.vue?vue&type=script&lang=ts&"
export * from "./ChoiceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports